import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import TransactionCompletionPage from './components/transaction-completion-page';
import Booking from './components/booking';
import ErrorBoundary from './components/error-boundary';
import AuthRedirect from './components/auth-redirect';

// Create a QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000, // 30 seconds
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// React 18 createRoot API
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
        <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Routes>
                <Route path="/" element={<App />} />

                {/* Routes with auth in URL (for initial access from email links) */}
                {/* AuthRedirect extracts auth, stores it, and redirects to clean URL */}
                <Route path="/booking/:auth/:uuid" element={<AuthRedirect><Booking /></AuthRedirect>} />
                <Route path="/approved/:auth/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />
                <Route path="/declined/:auth/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />
                <Route path="/cancelled/:auth/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />

                {/* Clean routes (after redirect, auth is in sessionStorage) */}
                <Route path="/booking/:uuid" element={<AuthRedirect><Booking /></AuthRedirect>} />
                <Route path="/approved/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />
                <Route path="/declined/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />
                <Route path="/cancelled/:uuid" element={<AuthRedirect><TransactionCompletionPage /></AuthRedirect>} />
            </Routes>
        </Router>
        </QueryClientProvider>
        </ErrorBoundary>
    </React.StrictMode>
);
